export function storeInRequest(params = {}) {
  return {
    type: '@estoqueproduto/STORE_IN_REQUEST',
    payload: { params },
  };
}

export function find(id) {
  return {
    type: '@estoqueproduto/FIND',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@estoqueproduto/FAILED_REQUEST',
  };
}

export function deleteRegister(id, params) {
  return {
    type: '@estoqueproduto/DELETE',
    payload: { id, params },
  };
}

export function updateRegister(data, params) {
  return {
    type: '@estoqueproduto/UPDATE',
    payload: { data, params },
  };
}

export function storeRegister(data, params) {
  return {
    type: '@estoqueproduto/STORE',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@estoqueproduto/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@estoqueproduto/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@estoqueproduto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@estoqueproduto/RECORD_FILTERING',
    payload: { params },
  };
}

export function resetFiltering(params = {}) {
  return {
    type: '@estoqueproduto/RESET_FILTERING',
    payload: { params },
  };
}
